import React from "react";
import { Flex } from "grid-styled";
import Loader from "./PulseLoader";

const CenteredLoader = props => (
  <Flex p={3} justify="center">
    <Loader {...props} />
  </Flex>
);

export default CenteredLoader;



// WEBPACK FOOTER //
// ./src/components/CenteredLoader.js